export default __webpack_public_path__ + "static/media/gears.1454faea.svg";